module.exports = __webpack_public_path__ + "static/media/fm1010-obd-ii-tracker-14.a164ce4d.jpg";